// @ts-nocheck
import { useQuery } from "@apollo/client";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formikinitialvalues } from "../../../CommonFunction/common";
import FormInputSection from "../../Templets/FormInputSection/FormInputSection";
import "./ForminputSection.scss";
import { CheckfieldExistornot, CheckTypeofInput, PINCODE_QUERY, validationAdditional } from "./formUtils.js";
import { Formik_Vschema } from "./Validation";
import { flushSync } from "react-dom";

export const FormInputSectionComponent = ({
  inputfields,
  accountId,
  fielddata,
  Type,
  onErrorsChange = (newErrors) => { },
  onhandleFormikChange = (values) => { },
  onSubmitForm = () => { },
  onResetForm = () => { },
  ValidationName = null,
  TypeOfPortal = "Add ",
  formkey = "",
  setAllFieldsData = (any) => { },
  setFirstLoad = (any) => { },
  TaxType = "",
  isFirstLoad = false,
  formRef = {},
  AllDynamicFunctions = () => { },
  FormData = null,
}) => {
  const prevErrorsRef = useRef();
  const [fields, setfields] = useState(inputfields);
  const [pincode, setpincode] = useState(0);
  const [userType, setUserType] = useState({});
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [showNotintrestedModal, setShowNotintrestedModal] = useState(false);
  const [pincodedata, setpincodedata] = useState();
  const [initialFormValues, setInitialFormValues] = useState({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);

  const { data, error } = useQuery(PINCODE_QUERY, {
    variables: { pincode: String(pincode) },
    skip: String(pincode).length !== 6,
    context: {
      headers: userType,
    },
  });

  const dependentFields = fields?.filter((field) => field.valueDependOn)[0];
  const valuesFromRedux = FormDataFromRedux?.MasterData?.[formkey]?.[dependentFields?.valueDependOn?.field];

  const formik = useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: Formik_Vschema(fields),
    enableReinitialize: true,
    validateOnChange: true,

    onSubmit: (values, { resetForm }) => { },
  });

  useEffect(() => {
    let value = dependentFields?.valueDependOn?.value;

    formik.setFieldValue(dependentFields?.name, valuesFromRedux?.[value]);
  }, [valuesFromRedux]);

  useEffect(() => {
    setfields(validationAdditional(inputfields));
  }, [inputfields]);

  useEffect(() => {
    setpincodedata(data);
  }, [data]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (TypeOfPortal === "Add" && formkey === "LR_Center_Master_Data") {
      if (formik.values?.Auto_CN_No === false) {
        formik.setFieldValue("Editable", true);
      }
    }
  }, [formik.values?.Auto_CN_No]);

  // console.log({ [Type]: formik.values }, "formik.valuesSidebyside");
  useEffect(() => {
    if (formRef && Type) {
      formRef.current[Type] = {
        submitForm: formik.submitForm,
        resetForm: (InpType) => {
          if (InpType) {
            // Get the filtered fields by the specified type
            const filteredFields = CheckTypeofInput(fields, InpType);
            // console.log(filteredFields);
            // Loop through each filtered field and set its value to null
            filteredFields?.forEach((field) => {
              if (field?.name) {
                formRef.current?.[Type]?.updateSingleField(field.name, null);
              }
            });
          } else formik.resetForm();
        },
        updateForm: (newValues) => {
          // console.log(newValues, fields);
          let arr = [];
          for (let a = 0; a < fields?.length; a++) {
            if (fields[a].name === "Sidebyside") {
              for (let b = 0; b < fields[a].Subfields.length; b++) {
                const subfield = fields[a].Subfields[b];
                let fieldValue = newValues[subfield.name] ?? (["checkbox"].includes(subfield.type) ? false : null);
                arr.push({ [subfield.name]: fieldValue });
              }
            } else {
              let fieldValue = newValues[fields[a].name] ?? (["checkbox"].includes(fields[a]?.type) ? false : null);
              arr.push({ [fields[a].name]: fieldValue });
            }
          }

          const obj = arr.reduce((acc, cur) => ({ ...acc, ...cur }), {});
          // console.log(obj);
          formik.setValues({ ...formik.values, ...obj });
        },
        updateSingleField: (name, value) => {
          let fieldExists = CheckfieldExistornot(fields, name);
          // console.log(name, value, fieldExists);
          // Update the field value only if it exists
          if (fieldExists) {
            // console.log(name, value);
            formik.setFieldValue(name, value);
          } else {
            console.warn(`Field with name "${name}" does not exist in the fields array.`);
          }
        },

        formclearFields: (InpType) => { },
        values: formik.values,
      };
    }

    return () => {
      // if (formRef && Type && Type !== "Mark_Delivery_Details") {
      //   delete formRef.current[Type];
      // }
    };
  }, [formRef, Type, formik]);

  useEffect(() => {
    if (prevErrorsRef.current !== formik.errors) {
      const Err_Type = ValidationName ? ValidationName : Type;
      const errors = { [Err_Type]: formik.errors };
      onErrorsChange(errors);
      prevErrorsRef.current = formik.errors;
    }
  }, [formik.errors, onErrorsChange, Type, formik.values]);

  const handldeUpdatePincodeValue = (name, value) => {
    if (formRef.current && formRef.current?.[Type]?.updateSingleField) {
      // console.log({ name, value }, "Name and value upading in this function");
      formRef.current?.[Type]?.updateSingleField(name, value);
    }
  };

  useEffect(() => {
    const fetchPincodeDetails = async () => {
      if (pincodedata?.pincode?.length) {
        const city = pincodedata.pincode[0].District;
        const state = pincodedata.pincode[0].State;
        handldeUpdatePincodeValue("Business_City", city);
        handldeUpdatePincodeValue("Business_State", state);
      }
    };
    setpincode(formik.values.Business_Pincode);
    if (/^\d{6}$/.test(formik.values.Business_Pincode)) {
      fetchPincodeDetails();
    }
  }, [formik.values.Business_Pincode, formik.values.Pincode, pincodedata]);

  useEffect(() => {
    const fetchPincodeDetails = async () => {
      if (pincodedata?.pincode?.length) {
        const city = pincodedata.pincode[0].District;
        const state = pincodedata.pincode[0].State;
        handldeUpdatePincodeValue("City", city);
        handldeUpdatePincodeValue("State", state);
      }
    };
    setpincode(formik.values.Pincode);
    if (/^\d{6}$/.test(formik.values.Pincode)) {
      fetchPincodeDetails();
    }
  }, [formik.values.Pincode, pincodedata]);

  useEffect(() => {
    setpincode(formik.values.Loading_Pincode);
    const fetchPincodeDetails = async () => {
      if (pincodedata) {
        const city = pincodedata.pincode[0].District;
        const state = pincodedata.pincode[0].State;

        handldeUpdatePincodeValue("Residential_City", city);
        handldeUpdatePincodeValue("Residential_State", state);
      }
    };
    setpincode(formik.values.Residential_Pincode);
    if (/^\d{6}$/.test(formik.values.Residential_Pincode)) {
      fetchPincodeDetails();
    }
  }, [formik.values.Residential_Pincode, pincodedata]);

  useEffect(() => {
    const values = { [Type]: formik.values };
    // console.log(formik.values, "formik.values", formRef.current);
    onhandleFormikChange(formik.values);
    formik.validateForm();
  }, [formik.values, Type]);

  const determineVisibility = (field) => {
    if (field.header && field.name === "Pincode") {
      setUserType(field.header);
    }
    // console.log(field, formRef.current);
    if (field.dependOn) {
      const { section, name, visibleOn } = field.dependOn;

      if (formRef.current[section]?.values[name] === visibleOn) {
        return true;
      } else if (formRef.current[section]?.values[name]) {
        if (formik.errors?.[field.name]) {
          delete formik.errors[field.name];
        }
        // console.log(formik.errors, "formik.errorsformik.errors1");
        let key = field.name;
        if (formik.values[key]) {
          formik.setFieldValue(key, "");
          if (field?.type === "InputDropForQuery") {
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: formkey,
                data: {
                  [field.name]: "",
                },
              },
            });
          }
        }
        return false;
      } else if (FormData?.[name] === visibleOn) {
        return true;
      }
      if (formik.errors?.[field.name]) {
        delete formik.errors[field.name];
      }
      // console.log(formik.errors, "formik.errorsformik.errors2");
      return false;
    }

    return true; // Fields without a dependOn property are always visible
  };

  const determineDisability = (field) => {
    if (field?.disableDependOn) {
      const { section, name, disableOn, value, disableOnValue } = field.disableDependOn;
      // console.log(FormDataFromRedux?.MasterData, FormDataFromRedux?.MasterData?.[formkey]?.[name], field);
      const dependentSection =
        FormDataFromRedux?.MasterData?.[formkey]?.[name]?.[disableOn] || formRef.current?.[section]?.values[name];
      // console.log(
      //   { dependentSection, section, name, disableOn, value, disableOnValue },
      //   formRef.current?.[section]?.values[name]
      // );
      // console.log(
      //   dependentSection !== null && dependentSection !== undefined && disableOnValue !== dependentSection,
      //   disableOnValue,
      //   dependentSection
      // );
      if (dependentSection !== null && dependentSection !== undefined && disableOnValue !== dependentSection) {
        return { ...field, disabled: false };
      } else {
        let key = field.name;
        if (value && formik.values[key] !== value) {
          formik.setFieldValue(key, value);
        }

        return { ...field, disabled: true };
      }
    }
    return field;
  };


  return (
    <>
      <form onSubmit={onSubmitForm} autoComplete="off">
        <FormInputSection
          fields={fields}
          formik={formik}
          fielddata={fielddata}
          formikhandleInputChange={async (evt) => {
            const { name, value, type } = evt.target;
            const newValue = value === "" ? null : type === "number" ? evt.target.valueAsNumber : value;


            // this update happens *synchronously*
            flushSync(() => setFirstLoad(true));

            // now it's safe to call Formik immediately
            formik.setFieldValue(name, newValue);
          }}
          errors={formik.errors}
          touched={formik.touched}
          handleBlur={formik.handleBlur}
          accountId={accountId}
          determineVisibility={determineVisibility}
          determineDisability={determineDisability}
          formkey={formkey}
          TypeOfPortal={TypeOfPortal}
          formReference={formRef}
          Type={Type}
          AllDynamicFunctions={AllDynamicFunctions}
        />
      </form>
    </>
  );
};

FormInputSectionComponent.propTypes = {
  alldata: PropTypes.any,
  fields: PropTypes.any,
  inputfields: PropTypes.any.isRequired,
  accountId: PropTypes.any,
  fielddata: PropTypes.any,
  Type: PropTypes.any,
  validation_Schema: PropTypes.any,
  onErrorsChange: PropTypes.func,
  TypeOfPortal: PropTypes.string,
  formkey: PropTypes.string,
  GetAllValues: PropTypes.func,
  onSubmitForm: PropTypes.func,
  onReset: PropTypes.func,
};

FormInputSectionComponent.defaultProps = {
  validation_Schema: {},
  onErrorsChange: () => { },
  TypeOfPortal: "Add", // Correct default value in defaultProps
  formkey: "",
  onSubmitForm: () => { },
  onResetForm: () => { },
};
